import { InputBase } from '@mui/material';
import styled from 'styled-components';

export const NavBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: 100px;
  background-color: #000;
  border-bottom: 1px solid #03251a;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;

  @media (max-width: 768px) {
    padding: 0 10px;
  }
`;

export const NavItemWithSub = styled.div`
  position: relative;
  display: inline-block;

  &:hover > div {
    display: block;
  }
`;

export const SubMenu = styled.div`
  display: none;
  position: absolute;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 160px;
  z-index: 999;
`;

export const SubMenuItem = styled.a`
  color: black;
  padding: 12px 16px;
  display: block;
  text-decoration: none;

  &:hover {
    background-color: #f2f2f2;
  }
`;

export const Logo = styled.img`
  @media (max-width: 768px) {
    height: 50px;
    width: 50px;
    order: 2;
  }
  width: 60px;
  height: 60px;
`;

export const NavItem = styled.a`
  color: white;
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  &:hover {
    color: #fff;
  }

  @media (max-width: 768px) {
    display: none; /* Esconder os links em telas menores */
  }
`;

export const SearchInput = styled(InputBase)`
  background-color: white;
  padding: 5px 10px;
  border-radius: 15px;
  width: 200px;

  @media (max-width: 768px) {
    width: 150px;
    order: 3;
  }
`;

export const containerStyled = {
  backgroundColor: '#000',
  minHeight: '100vh',
  paddingTop: '100px',
};

export const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: #92b21f;
  font-size: 24px;
  cursor: pointer;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    order: 1;
  }
`;

export const drawerStyled = {
  width: 250,
  height: '100%',
  backgroundColor: '#333',
  color: '#92b21f',
  borderRight: '1px solid #03251a',
};
